import type { TFunction } from 'i18next';

/**
 * Доступное имя кнопки удаления повторяемого элемента (ТЗ 0073, 5.2).
 *
 * Читалка должна различать «Usuń umiejętność Python» и «Usuń projekt TaskFlow»,
 * а не слышать безымянную кнопку. У нового, ещё не заполненного элемента имени
 * нет — тогда общее «Usuń pozycję», а не «Usuń projekt » с пустым хвостом.
 */
export const removeLabel = (t: TFunction, key: string, name?: string | null) => {
  const trimmed = (name ?? '').trim();
  return trimmed ? `${t(key, { name: trimmed })}` : `${t('careerProfile.remove.item')}`;
};
